export default "__VITE_ASSET__caedc4ed__"